<template>
  <div>
    <hit_login>

      <hit_dashboard v-if="typeof $store.getters.board_avg != 'undefined' && $store.getters.board_avg && Object.keys($store.getters.board_avg).length">

          <div class="hit-panel hit-panel-warning">

            <div class="hit-panel-heading">
              <i class="hit-glyphicon hit-glyphicon-brush"></i> {{ $tc("message.color", 2) }}
            </div>

            <div class="hit-panel-body">
              <div class="hit-form-group">
                <div v-for="(element, index) in form2" v-bind:class="get_class(element[0])">
                  <div class="hit-form-group">
                    <label class="hit-html-label" v-bind:for="'form2_'+index" v-html="get_label(element)"></label>
                    <hit_color :id="'form2_'+index" :color="colors[ element[1] ]" :callback="function(col){ set_color(col, element[1]); }"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="hit-panel-heading">
              <i class="hit-glyphicon hit-glyphicon-embed"></i> {{ $tc("message.embed", 1) }}
            </div>

            <div class="hit-panel-body">
              <div class="hit-row">
                <div class="hit-col-md-3">
                  <div class="hit-form-group">
                    <a href="#" class="hit-btn  hit-btn-block" :class="get_exclude_class(name, ['hit-btn-success', 'hit-btn-danger'])" v-for="name in pos" v-on:click.prevent="set_exclude(name)">
                      <i class="hit-glyphicon" :key="exclude_key+'_'+name" :class="get_exclude_class(name, ['hit-glyphicon-ok', 'hit-glyphicon-remove'])"></i> {{ $tc("message."+name, 1) }}
                    </a>
                  </div>
                </div>

                <div class="hit-col-md-9" v-if="get_embed_code()">
                  <hit_embed_code :code="get_embed_code()" />
                </div>

              </div>
            </div>

            <div class="hit-panel-heading" v-if="get_embed_code()">
              <i class="hit-glyphicon hit-glyphicon-eye-open"></i> {{ $tc("message.preview", 2) }}
            </div>

            <div class="hit-panel-body" v-if="get_embed_code()">
              <div class="hit-row">

                <draggable handle=".handle" v-model="pos">

                    <component v-for="name in pos" :key="exclude_key+'_'+name" v-if="!get_exclude(name) && survey" v-bind:is="'embed_'+name" :width="width" :survey="survey" :set_width="set_width" :colors="colors" :board="board" :pos="pos" :design="design" :curr_key="curr_key" :get_width="get_width" :get_badge="get_badge" />

                </draggable>

              </div>
            </div>
          </div>

      </hit_dashboard>

    </hit_login>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import embed_badge from '@core/components/content/app/embed_badge.vue'
import embed_board from '@core/components/content/app/embed_survey.vue'
import embed_feedback from '@core/components/content/app/embed_votes.vue'

export default{
  components: {draggable, embed_badge, embed_board, embed_feedback},

  data: function () {
    var colors = {}

    var badges = Object.keys(this.$store.getters.badges)
    var votings = Object.keys(this.$store.getters.votings)

    return {

      survey: { },
      board: {},
      design: {
        badge: badges[0],
        survey: 'Alphonso',
        votings: votings[0]
      },

      colors: this.$store.getters.user,

      form: [
        [4, 'badge', badges[0], badges],
        [4, 'text_color'],
        [4, 'accent_color']

      ],

      form2: [
        [3, 'background_color'],
        [3, 'text_color'],
        [3, 'accent_color'],
        [3, 'accent_color2', this.$tc('message.accent_color', 1) + ' 2']
      ],

      width: {
        badge: 4,
        board: 8,
        feedback: 12
      },

      pos: ['badge', 'board', 'feedback'],
      exclude: {},
      exclude_key: new Date().getTime(),
      curr_key: new Date().getTime()
    }
  },

  watch: {
    'design.badge': function (val) { this.curr_key = new Date().getTime() }
  },
  methods: {

    get_embed_code: function () {
      if (typeof this.board === 'undefined' || typeof this.board[ this.$route.params.boardID ] === 'undefined') {
        this.get_badge()
        return ''
      }
      if (!this.colors) {
        this.colors = this.$store.getters.user
        return ''
      }

      var board = this.board[ this.$route.params.boardID ]
      var width = this.width
      var my_class = this
      var design = this.design

      var code = {
        'language': this.$store.getters.lang,
        'board': board.ID,
        'user': this.$store.getters.user.username,
        'embed': [],
        'colors': {
          text_color: this.colors.text_color,
          background_color: this.colors.background_color,
          accent_color: this.colors.accent_color,
          accent_color2: this.colors.accent_color2
        },
        'width': [],
        'design': design

      }

      this.pos.forEach(function (section) {
        if (typeof my_class.exclude[section] !== 'undefined' && my_class.exclude[section]) { return true }

        code.embed.push(section)
        code.width.push(width[section])
      })

      if (!code.width.length) { return '' }

      return code
    },

    get_exclude_class: function (name, arr) {
      if (typeof this.exclude[name] === 'undefined') { return arr[0] }

      return arr[ (this.exclude[name] * 1) ]
    },

    get_exclude: function (name) {
      return this.exclude[name]
    },
    set_exclude: function (name) {
      if (typeof this.exclude[name] === 'undefined') { this.exclude[name] = false }

      this.exclude[name] = !this.exclude[name]

      this.exclude_key = new Date().getTime()
    },

    set_width: function (width, type) {
      this.width[type] = width
    },
    get_width: function (type) {
      var r = {}
      r[ 'hit-col-md-' + this.width[type] ] = true

      return r
    },
    get_badge: function () {
      this.survey = this.$store.getters.board_avg
      this.board = this.$store.getters.boards_by_id

      if (typeof this.board === 'undefined' || typeof this.board[this.$route.params.boardID] === 'undefined') { return false }

      return { name: this.board[this.$route.params.boardID].name, votes: this.survey[this.$route.params.boardID], badge: {bg: this.colors.background_color, accent: this.colors.accent_color, text: this.colors.text_color, pluscolor: this.colors.accent_color2} }
    },
    set_color: function (color, id) {
      this.colors[id] = color
      this.curr_key = new Date().getTime()
    },
    get_label: function (element) {
      if (typeof element[2] !== 'undefined') { return element[2] }

      return this.$tc('message.' + [element[1]], 1)
    },

    get_class: function (col) {
      var obj = {}; obj['hit-col-md-' + col ] = true; return obj
    }

  },

  metaInfo: function () {
    return {
      title: this.$tc('message.board', 1) + ' | ' + this.$tc('message.embed', 2)
    }
  },

  mounted () {
    this.$store.dispatch('get_user_boards')
    this.$store.dispatch('get_all_votes')
  }

}

</script>
